import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class AccountDefinition {

  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  exchangeCode: string | undefined;

  @JsonProperty()
  clearingHouse: string | undefined;

  @JsonProperty()
  customerId: number | undefined;

  @JsonProperty()
  customerName: string | undefined;

  @JsonProperty()
  owner: string | undefined;

  @JsonProperty()
  accountTypeCode: string | undefined;

  @JsonProperty()
  reference1: string | undefined;

  @JsonProperty()
  reference2: string | undefined;

  @JsonProperty()
  reference3: string | undefined;

  @JsonProperty()
  giveUpBrokerCode: string | undefined;

  @JsonProperty()
  giveUpMessage: string | undefined;

  @JsonProperty()
  giveupMessage2: string | undefined;

  @JsonProperty()
  giveupMessage3: string | undefined;

  @JsonProperty()
  giveupAccountType: string | undefined;

  @JsonProperty()
  giveUpCommission: string | undefined;

  @JsonProperty()
  executionFee: string | undefined;

  @JsonProperty()
  openCloseForFutures: AccountDefinition.OpenClose | undefined;

  @JsonProperty()
  openCloseForOptions:  AccountDefinition.OpenClose | undefined;

  @JsonProperty()
  allFutures: boolean = true;

  @JsonProperty()
  allOptions: boolean = true;

  @JsonProperty()
  contractList: string | undefined;

  @JsonProperty()
  contractListInclude: boolean = false;

  @JsonProperty()
  disabled: boolean = false;

  @JsonProperty()
  enabled: boolean = true;

  @JsonProperty()
  waitForApproval: boolean = true;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  apsManagement: boolean = false;

  @JsonProperty()
  traderName: string | undefined;

  @JsonProperty()
  lastActivityDate: DateTime = DateTime.now();

  @JsonProperty()
  moneyOwner: string | undefined;

  @JsonProperty()
  agreementId: string | undefined;

  @JsonProperty()
  bindTraderToMemo: boolean = false;
}

export module AccountDefinition {
  export enum OpenClose {
    NO = 'NO',
    OPEN = 'OPEN',
    CLOSE = 'CLOSE',
    MARKET = 'MARKET',
    POSITION = 'POSITION'
  }
}
